import script from "./SheetForeignFlipReady.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetForeignFlipReady.vue?vue&type=script&setup=true&lang=ts"

import "./SheetForeignFlipReady.vue?vue&type=style&index=0&id=19b67590&lang=css"

const __exports__ = script;

export default __exports__